/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferentialItemDto } from './ReferentialItemDto';
import {
    ReferentialItemDtoFromJSON,
    ReferentialItemDtoFromJSONTyped,
    ReferentialItemDtoToJSON,
    ReferentialItemDtoToJSONTyped,
} from './ReferentialItemDto';

/**
 * Définition d'une variable d'expression.
 * @export
 * @interface VariableDto
 */
export interface VariableDto {
    /**
     * 
     * @type {string}
     * @memberof VariableDto
     */
    id?: string;
    /**
     * 
     * @type {ReferentialItemDto}
     * @memberof VariableDto
     */
    typeVariable?: ReferentialItemDto;
    /**
     * 
     * @type {string}
     * @memberof VariableDto
     */
    typeVariableId?: string;
    /**
     * 
     * @type {string}
     * @memberof VariableDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VariableDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VariableDto
     */
    value?: number;
}

/**
 * Check if a given object implements the VariableDto interface.
 */
export function instanceOfVariableDto(value: object): value is VariableDto {
    return true;
}

export function VariableDtoFromJSON(json: any): VariableDto {
    return VariableDtoFromJSONTyped(json, false);
}

export function VariableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'typeVariable': json['typeVariable'] == null ? undefined : ReferentialItemDtoFromJSON(json['typeVariable']),
        'typeVariableId': json['typeVariableId'] == null ? undefined : json['typeVariableId'],
        'code': json['code'] == null ? undefined : json['code'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function VariableDtoToJSON(json: any): VariableDto {
    return VariableDtoToJSONTyped(json, false);
}

export function VariableDtoToJSONTyped(value?: VariableDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'typeVariable': ReferentialItemDtoToJSON(value['typeVariable']),
        'typeVariableId': value['typeVariableId'],
        'code': value['code'],
        'libelle': value['libelle'],
        'value': value['value'],
    };
}

